// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChm7GQZRVRQaCVlRD_pUgo2Uq8CPZb-6Q",
  authDomain: "climbingcert.firebaseapp.com",
  projectId: "climbingcert",
  storageBucket: "climbingcert.firebasestorage.app",
  messagingSenderId: "753843036907",
  appId: "1:753843036907:web:dce3bc18d77020905f94ae",
  measurementId: "G-23W1KWZ6Y3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);


export {auth, analytics, db};